import { SearchResult } from "@/service/api";

export interface SearchState {
  searchQuery: string;
  searchResults: SearchResult[];
  setSearchQuery: (query: string) => void;
  setSearchResults: (results: SearchResult[]) => void;
  clearSearch: () => void;
}

export const initialSearchState = {
  searchQuery: '',
  searchResults: [],
};

export const searchSlice = (set: any) => ({
  ...initialSearchState,
  setSearchQuery: (query: string) => set({ searchQuery: query }),
  setSearchResults: (results: SearchResult[]) => set({ searchResults: results }),
  clearSearch: () => set(initialSearchState),
});
